import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import { useAllOrganizationsOnboardingCounts } from "../../service/organization";

interface OnboardingCountCellProps {
  organizationId: string;
}

export function OnboardingCountCell({
  organizationId,
}: OnboardingCountCellProps) {
  const { data: onboardingCounts, isLoading } =
    useAllOrganizationsOnboardingCounts();

  if (isLoading) {
    return <Skeleton className="h-4 w-6" />;
  }

  return <span>{onboardingCounts?.[organizationId] || 0}</span>;
}
